import React, { Component } from "react";
import { serviceProps } from "../../../interfaces/interfaces";
import Helmet from "react-helmet";

import styles from "./Service.module.scss";

class Service extends Component<serviceProps> {
  constructor(props: serviceProps) {
    super(props);
  }

  render() {
    const headerImageProps = {
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundImage: `url(${this.props.image})`
    };

    return (
      <div id={styles.container}>
        <Helmet>
          <title>{this.props.title}</title>
          <meta name="description" content={this.props.description} />
        </Helmet>
        <div id={styles.headerImage} style={headerImageProps}>
          <div id={styles.headerText}>{this.props.title}</div>
        </div>
        <div id={styles.contentContainer}>
          <div id={styles.logo}>{this.props.logo}</div>
          <div id={styles.content}>{this.props.description}</div>
        </div>
      </div>
    );
  }
}

export default Service;
